"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactOwnerType = exports.ExploreSort = void 0;
var ExploreSort;
(function (ExploreSort) {
    ExploreSort["LATEST"] = "latest";
    ExploreSort["AUCTION"] = "auction";
    ExploreSort["BUY_NOW"] = "buy_now";
    ExploreSort["PRICE_ASC"] = "price_asc";
    ExploreSort["PRICE_DESC"] = "price_desc";
})(ExploreSort = exports.ExploreSort || (exports.ExploreSort = {}));
var ContactOwnerType;
(function (ContactOwnerType) {
    ContactOwnerType[ContactOwnerType["Unknown"] = 0] = "Unknown";
    ContactOwnerType[ContactOwnerType["NFT"] = 1] = "NFT";
    ContactOwnerType[ContactOwnerType["Collection"] = 2] = "Collection";
})(ContactOwnerType = exports.ContactOwnerType || (exports.ContactOwnerType = {}));
